import { mapState } from 'vuex';
export default {
  name: 'SelectLocalSearchField',
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      required: true
    },
    selectOptions: {
      type: Array,
      default: () => []
    },
    isLoadingOptions: {
      type: Boolean,
      default: false
    },
    canAddRule: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled'])
  }
};